export default __webpack_public_path__ + "img/2ac6a7c62c9a1a5f1c6dd608c4fe2399.svg";